"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class SiteDefinition {
  constructor() {
    _defineProperty(this, "pathPattern", null);
    _defineProperty(this, "framework", true);
    _defineProperty(this, "headerShowTitleExternal", false);
    _defineProperty(this, "isMultiSite", false);
    _defineProperty(this, "isMegaMenu", true);
    _defineProperty(this, "isProfile", false);
    _defineProperty(this, "isRunAs", false);
    _defineProperty(this, "isWebUserReset", false);
    _defineProperty(this, "defaultPath", '/home.html');
    _defineProperty(this, "logoutPath", '/logout.html');
    _defineProperty(this, "loginPath", '/login.html');
    _defineProperty(this, "notFoundPath", '/404');
    _defineProperty(this, "profilePath", '/profile.html');
    _defineProperty(this, "loginText", null);
    _defineProperty(this, "loginGreetingTitle", 'Welcome back');
    _defineProperty(this, "loginGreetingSubTitle", null);
    _defineProperty(this, "defaultLoginMethod", null);
    _defineProperty(this, "securityCodeTitle", 'Security Code');
    _defineProperty(this, "clientId", null);
    _defineProperty(this, "contactUsEmail", null);
    _defineProperty(this, "siteDescription", '[Please provide a description]');
    _defineProperty(this, "siteId", null);
    _defineProperty(this, "siteName", null);
    _defineProperty(this, "siteTag", '[Please provide the site tag]');
    _defineProperty(this, "siteTitle", '[Site Title]');
    _defineProperty(this, "siteSubTitle", '[Site Sub Title]');
    _defineProperty(this, "welcomeTitle", '[Please provide the site welcome]');
  }
}
exports.default = SiteDefinition;
//# sourceMappingURL=SiteDefinition.js.map